import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCaretDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 12 12" {...props}>
    <g clipPath="url(#caret-down_svg__clip0_2060_529)">
      <path
        fillRule="evenodd"
        d="M5.676 9.24c.21.176.404.176.58 0l4.785-4.736c.21-.209.21-.403 0-.58-.21-.208-.404-.208-.58 0l-4.493 4.3-4.471-4.303c-.21-.194-.411-.194-.606 0-.209.176-.209.37 0 .58l4.785 4.74Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export default SvgCaretDown;
